module.exports = __webpack_public_path__ + "media/images/pic/popup/icon-video-57b362844100122d7930c26f7b7b57fa.png";